import { Inject, Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlags } from '../features';

@Injectable({ providedIn: 'root' })
export class AccessFullscreenInboxGuard {
  constructor(
    private readonly router: Router,
    @Inject(FeatureFlags.FULLSCREEN_INBOX_VIEW) private readonly fullscreenInboxEnabled$: Observable<boolean>,
  ) {}

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    const isOutlet = !!route.outlet;

    return this.fullscreenInboxEnabled$.pipe(
      map((isEnabled) => {
        const shouldMatch = isOutlet ? !isEnabled : isEnabled;

        if (shouldMatch) {
          return true;
        }

        if (isOutlet && isEnabled) {
          const redirectPath = segments.map((s) => s.path).join('/');
          return this.router.parseUrl(`/${redirectPath}`);
        }

        return false;
      }),
      catchError((err) => {
        console.error('Error evaluating feature flag for fullscreen inbox:', err);
        return of(false);
      }),
    );
  }
}
